export * as connectedDomains from '@wix/auto_sdk_domains_connected-domains/schemas';
export * as connectedDomainSetupInfo from '@wix/auto_sdk_domains_connected-domain-setup-info/schemas';
export * as dnsPropagation from '@wix/auto_sdk_domains_dns-propagation/schemas';
export * as domainDns from '@wix/auto_sdk_domains_domain-dns/schemas';
export * as domainAvailability from '@wix/auto_sdk_domains_domain-availability/schemas';
export * as domainSuggestions from '@wix/auto_sdk_domains_domain-suggestions/schemas';
